import ListHeader from '../../../components/ListHeader';
import CommonHighlights from '../../serviceProvider/components/CommonHighlights';
import { IServiceInfo } from '../../serviceProvider/types/interfaces';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface SalesDataProps {
  salesData: any;
  purchasesVehiclesData: any;
}

const SalesData = ({salesData, purchasesVehiclesData}: SalesDataProps) => {
  const { t, i18n } = useTranslation();

  const salesBasicData = useMemo(() => {
    return [
      {
        title: t('dashboardCharts.total_sales'),
        number: `${salesData?.data?.data?.total_sales.toLocaleString('en-US')} ${t('sar')}` || 0
      },
      {
        title: t('dashboardCharts.total_vehicles_purchased'),
        number: purchasesVehiclesData?.data?.data?.total_vehicles_purchased || 0
      },
    ];
  }, [salesData, t]);

  // const topSalesData = useMemo(() => {
  //   if (!salesData?.top_sales) return [];

  //   return salesData.top_sales
  //     .sort((a, b) => b.value - a.value)
  //     .map((item) => ({
  //       title: item.name,
  //       number: item.value.toLocaleString('en-US')
  //     }));
  // }, [salesData]);

  // const topSalesProductsData = useMemo(() => {
  //   if (!salesData?.top_selling_products) return [];

  //   return salesData.top_selling_products
  //     .sort((a, b) => b.total_vehicle_price - a.total_vehicle_price)
  //     .map((item) => ({
  //       title: item.product_name,
  //       number: item.total_vehicle_price.toLocaleString('en-US')
  //     }));
  // }, [salesData]);

  // const topSalesOffersData = useMemo(() => {
  //   if (!salesData?.top_selling_offers) return [];

  //   return salesData.top_selling_offers
  //     .sort((a, b) => b.total_vehicle_price - a.total_vehicle_price)
  //     .map((item) => ({
  //       title: item.offer_name || '',
  //       number: item.total_vehicle_price.toLocaleString('en-US')
  //     }));
  // }, [salesData, i18n.language]);

  // const [activeTab, setActiveTab] = useState('applications_number');

  // const tabs = useMemo(
  //   () => [
  //     { title: t('dashboardCharts.applications_number'), value: 'applications_number' },
  //     { title: t('dashboardCharts.applications_value'), value: 'applications_value' }
  //   ],
  //   [t]
  // );

  return (
    <>
      <ListHeader customClass="row noMargin">
        <h2>{t('dashboardCharts.sales')}</h2>
      </ListHeader>

      <div className="dashboard-data column">
        <div className="charts">
          <CommonHighlights data={salesBasicData as IServiceInfo[]} noBorder />

          {/* <ChartDirection>
            <ChartJsBarChart
              data={dataSet}
              title={t('dashboardCharts.applications')}
              yAxisLabel={t('dashboardCharts.applications')}
              tooltipLabel={t('dashboardCharts.value')}
              fill="#000"
              stroke="#000"
              innerHeader={
                <div className="dashboard-tabs-container">
                  <Tabs tabs={tabs} value={activeTab} setValue={setActiveTab} />
                </div>
              }
            />
          </ChartDirection> */}
        </div>

        {/*<div className="top-dashboard-data top-sales">
          <TopData data={topSalesProductsData} header={t('dashboardCharts.top_products')} />
          <TopData data={topSalesOffersData} header={t('dashboardCharts.top_offers')} />
          <TopData data={topSalesData} header={t('dashboardCharts.top_selling_iir')} />
          <TopData data={topSalesData} header={t('dashboardCharts.top_selling_retail')} />
        </div> */}
      </div>
    </>
  );
};

export default SalesData;
